import React from 'react';

export interface CompanyContextProps {
  country: string;
}

export const CompanyContext = React.createContext<CompanyContextProps>({
  country: 'UA',
});

export const useCompany = (): CompanyContextProps => {
  return React.useContext(CompanyContext);
};
